export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9565.7cf0b475.jpg";